module.exports = __webpack_public_path__ + "img/call-chat--mobile.963c8f8.webp";